<template>
  <el-select
    filterable
    collapse-tags
    v-model="selectedValue"
    :disabled="disabled"
    :clearable="!required"
    :multiple="multiple"
    :placeholder="required ? '必选' : '非必选'"
  >
    <el-option
      v-for="item in optionList"
      :label="item.basicBikeTypeName"
      :value="item.basicBikeTypeName"
      :key="item.basicBikeTypeId">
    </el-option>
  </el-select>
</template>

<script>
import uniqBy from 'lodash/uniqBy'

export default {
  name: 'filter-bike-type',

  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    value: {
      type: null,
    },
    name: {
      type: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    bikeTypeCategory: {
      type: Number,
    }
  },

  data() {
    return {
      optionList: [],
    }
  },

  computed: {
    selectedValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('update:value', val)
      },
    },
  },

  created() {
    this.getOptionList()
  },

  methods: {
    getOptionList() {
      if (this.optionList.length > 0 || !this.bikeTypeCategory) return
      const params = {
        bikeTypeCategory: this.bikeTypeCategory,
      }
      this.fetch
        .get('getBikeType', { params })
        .then((res) => {
          this.optionList = uniqBy(res.bikeTypeDTOS, 'basicBikeTypeId') || []
          if (this.required && this.optionList[0]) {
            this.selectedValue = this.multiple
              ? [this.optionList[0].basicBikeTypeName]
              : this.optionList[0].basicBikeTypeName
          }
        })
        .catch(() => {})
    },
  },
}
</script>
